<template>
	<div>
		<div @mousemove="move" class="w3l-banner">
			<div :style="'transform: translate(' +
			(position == 'left' ? '20' : '-20') +
			'px,' +
			(position2 == 'top' ? '10' : '-10') +
			'px) scale(1.1)'
			" class="banner-image"></div>
			<div class="titleBox" :class="contType == 'e' ? 'titleBoxe' : ''">


			</div>
		</div>

		<div class="twoSectionBoxStyle">
			<div class="twoSectionTitleBoxStyle" v-if="contType == 'z'">
				<div class="wow bounceInUp twoTitleT1Style">使用条款</div>
				<div class="wow bounceInUp twoTitleT2Style">
					<p class="t">1. 接受条款</p>
					<p>访问和使用索图科技技术有限公司（“索图科技”）的网站即表示您同意遵守以下条款和条件。如果您不同意这些条款，请不要使用我们的网站。</p>
					<p class="t">2. 条款变更</p>
					<p>索图科技保留在任何时候修改这些使用条款的权利，恕不另行通知。您继续使用网站即表示您接受修订后的条款。</p>
					<p class="t">3. 网站使用</p>
					<p>您同意仅将网站用于合法目的，并且不得以侵犯他人权利、限制或妨碍他人使用和享受网站的方式使用网站。</p>
					<p class="t">4. 知识产权</p>
					<p>本网站上的所有内容，包括但不限于文本、图形、标志和软件，均为索图科技或其内容供应商的财产，并受知识产权法保护。未经授权使用任何内容是被禁止的。</p>
					<p class="t">5. 责任限制</p>
					<p>索图科技不对因使用或无法使用本网站或其中任何内容而引起的任何直接、间接、附带、特殊或后果性损害承担责任，即使索图科技已被告知可能发生此类损害。</p>
					<p class="t">6. 第三方网站链接</p>
					<p>本网站可能包含指向第三方网站的链接。索图科技不对这些网站的内容或隐私实践负责，并鼓励您查看其条款和政策。</p>
					<p class="t">7. 隐私政策</p>
					<p>您使用本网站还受我们的隐私政策约束，可在<span @click="PrivacyPolicy"
							style="color: blue;cursor: pointer;">[此处]</span>访问。</p>
					<p class="t">8. 适用法律</p>
					<p>这些条款应受香港法律管辖并按其解释。因这些条款引起的任何争议应由香港法院专属管辖。</p>
					<p class="t">9. 联系信息</p>
					<p>如果您对这些条款有任何疑问，请联系我们： </p>
					<p>电子邮件：cs@suntone.com </p>
					<p>地址：索图科技技术有限公司</p>
					<p>香港特别行政区鲗鱼涌英皇道728号K11 Atelier 五楼545</p>
					<p><br></p>
				</div>
			</div>
			<div class="twoSectionTitleBoxStyle" v-if="contType == 'f'">
				<div class="wow bounceInUp twoTitleT1Style">使用條款</div>
				<div class="wow bounceInUp twoTitleT2Style">
					<p class="t">1. 接受條款</p>
					<p>訪問和使用索圖科技技術有限公司（「索圖科技」）的網站即表示您同意遵守以下條款和條件。如果您不同意這些條款，請不要使用我們的網站。</p>
					<p class="t">2. 條款變更</p>
					<p>索圖科技保留在任何時候修改這些使用條款的權利，恕不另行通知。您繼續使用網站即表示您接受修訂後的條款。</p>
					<p class="t">3. 網站使用</p>
					<p>您同意僅將網站用於合法目的，並且不得以侵犯他人權利、限製或妨礙他人使用和享受網站的方式使用網站。</p>
					<p class="t">4. 知識產權</p>
					<p>本網站上的所有內容，包括但不限於文本、圖形、標誌和軟件，均為索圖科技或其內容供應商的財產，並受知識產權法保護。未經授權使用任何內容是被禁止的。</p>
					<p class="t">5. 責任限製</p>
					<p>索圖科技不對因使用或無法使用本網站或其中任何內容而引起的任何直接、間接、附帶、特殊或後果性損害承擔責任，即使索圖科技已被告知可能發生此類損害。</p>
					<p class="t">6. 第三方網站鏈接</p>
					<p>本網站可能包含指向第三方網站的鏈接。索圖科技不對這些網站的內容或隱私實踐負責，並鼓勵您查看其條款和政策。</p>
					<p class="t">7. 隱私政策</p>
					<p>您使用本網站還受我們的隱私政策約束，可在<span @click="PrivacyPolicy"
							style="color: blue;cursor: pointer;">[此處]</span>訪問。</p>
					<p class="t">8. 適用法律</p>
					<p>這些條款應受香港法律管轄並按其解釋。因這些條款引起的任何爭議應由香港法院專屬管轄。</p>
					<p class="t">9. 聯系信息</p>
					<p>如果您對這些條款有任何疑問，請聯系我們： </p>
					<p>電子郵件：cs@suntone.com </p>
					<p>地址：索圖科技技術有限公司</p>
					<p>香港特別行政區鲗魚涌英皇道728號K11 Atelier 五樓545</p>
					<p><br></p>
				</div>
			</div>
			<div class="twoSectionTitleBoxStyle" v-if="contType == 'e'">

				<div class="wow bounceInUp twoTitleT1Style">Terms of Use</div>
				<div class="wow bounceInUp twoTitleT2Style">
					<p class="t">1. Acceptance of Terms</p>
					<p>By accessing and using the website of Suntone Technology Co., Limited ("Suntone Technology"), you
						agree to comply with and be bound by the following terms and conditions. If you do not agree to
						these terms, please do not use our website.</p>
					<p class="t">2. Changes to Terms</p>
					<p>Suntone Technology reserves the right to modify these terms of use at any time without prior
						notice.
						Your continued use of the website constitutes your acceptance of the revised terms.</p>
					<p class="t">3. Use of the Website</p>
					<p>You agree to use the website only for lawful purposes and in a manner that does not infringe the
						rights of, restrict, or inhibit anyone else's use and enjoyment of the website.</p>
					<p class="t">4. Intellectual Property</p>
					<p>All content on this website, including but not limited to text, graphics, logos, and software, is
						the
						property of Suntone Technology or its content suppliers and is protected by intellectual
						property
						laws. Unauthorized use of any content is prohibited.</p>
					<p class="t">5. Limitation of Liability</p>
					<p>Suntone Technology shall not be liable for any direct, indirect, incidental, special, or
						consequential damages resulting from the use or inability to use the website or any content
						therein,
						even if Suntone Technology has been advised of the possibility of such damages.</p>
					<p class="t">6. Links to Third-Party Sites</p>
					<p>This website may contain links to third-party websites. Suntone Technology is not responsible for
						the
						content or privacy practices of such websites and encourages you to review their terms and
						policies.
					</p>
					<p class="t">7. Privacy Policy</p>
					<p>Your use of the website is also governed by our Privacy Policy, which can be accessed [<span
							@click="PrivacyPolicy" style="color:blue; cursor: pointer;">here</span>].</p>
					<p class="t">8. Governing Law</p>
					<p>These terms shall be governed by and construed in accordance with the laws of Hong Kong. Any
						disputes
						arising under these terms shall be subject to the exclusive jurisdiction of the courts of Hong
						Kong.
					</p>
					<p class="t">9. Contact Information</p>
					<p>If you have any questions about these terms, please contact us at: </p>

					<p>Email: cs@suntone.com </p>
					<p>Address: </p>
					<p>Suntone Technology Co., Limited</p>
					<p>Room 545,5/F, K11 Atelier, 728 King's Road.Quarry Bay, Hong Kong</p>
					<p><br></p>
				</div>
			</div>

		</div>






	</div>
</template>
<!-- <script src="https://smtpjs.com/v3/smtp.js"></script> -->
<script>


import { Email } from "../utils/smtp.js";
import { WOW } from "wowjs";

export default {
	name: "index",
	data: (vm) => {
		return {
			bodyW: 0,
			bodyY: 0,
			position: "",
			position2: "",
			contList: {
			},
			contType: "z",

		};
	},
	methods: {
		PrivacyPolicy() {
			this.$router.push("/PrivacyPolicy");
		},
		move(e) {
			if (e.pageX > this.bodyW / 2) {
				this.position = "right";
			} else {
				this.position = "left";
			}
			if (e.pageY > 250) {
				this.position2 = "top";
			} else {
				this.position2 = "bottom";
			}
		},
		changeTypeTitleName() {
			if (this.contType == "f") {
				document.title = "使用條款";
			} else if (this.contType == 'e') {
				document.title = 'Terms of Use'
			} else {
				document.title = "使用条款";
			}
		}

	},

	mounted() {
		this.bodyW = document.body.clientWidth;
		this.bodyY = document.body.clientHeight;
		var that = this;
		this.contType = window.localStorage.getItem('language');
		that.changeTypeTitleName()
		window.addEventListener('setItemEvent', function (e) {
			if (e.key == "language") {
				that.contType = e.newValue;
				that.changeTypeTitleName()
			}
		})
		var wow = new WOW({
			boxClass: "wow",
			animateClass: "animated",
			offset: 40,
			mobile: true,
			live: true,
		});
		wow.init();
		//QOFGPGRDUUMNZALE


	},
};
</script>

<style src="../assets/css/AboutUs-pc.css" scoped></style>
<style src="../assets/css/AboutUs-phone.css" scoped></style>
<style scoped>
.titleBox {
	padding-top: 0px;
}

.w3l-banner {
	height: 130px;
}

.twoTitleT2Style {
	display: block;
	max-width: 1120px;
}

p {
	text-indent: 0%;
}

.t {
	margin-top: 10px;
	font-weight: 700;
}
</style>
<!-- </style> -->
